export default {
  pageTitle: "Application timeout",
  pageIntro: "For your security, your application has timed out.",
  pageCopy:
    "This happens if you leave it idle for more than 10 minutes. We have removed all the personal details you entered.",
  buttonLabel: "Start again"
};
